import ReviewAndRatingWidget from "@/widget/ReviewAndRatingWidget/ReviewAndRatingWidget.vue"
import QuestionAndAnswerWidget from "@/widget/QuestionAndAnswerWidget/QuestionAndAnswerWidget.vue"
import { BINDING_ELEMENT_ID, BINDING_TYPE } from "./constants/constants"
import { getDerivedProductValues } from "./utils/utils"

// Average Rating Widget Binding Component
const RnRAverageWidgetBinding = {
  render(h) {
    return h(ReviewAndRatingWidget, {
      props: {
        bindingType: BINDING_TYPE.AVERAGE_RATING,
      },
    })
  },
}

// Review And Rating Widget Binding Component
const RnRWidgetBinding = {
  render(h) {
    return h(ReviewAndRatingWidget, {
      props: {
        bindingType: BINDING_TYPE.REVIEW_AND_RATING,
      },
    })
  },
}

// Average Rating Widget Binding
window.FPI.extension.register(`#${BINDING_ELEMENT_ID.AVERAGE_RATING}`, {
  mounted(element) {
    window.FPI.extension.mountApp({
      element,
      component: RnRAverageWidgetBinding,
    })
  },
})

// Review & Rating Widget Binding
window.FPI.extension.register(`#${BINDING_ELEMENT_ID.REVIEW_AND_RATING}`, {
  mounted(element) {
    window.FPI.extension.mountApp({
      element,
      component: RnRWidgetBinding,
    })
  },
  destroyed() {
    const fpiProductData = window.FPI?.state?.product?._data?.product
    window.rnr_product_id = getDerivedProductValues(fpiProductData)?.productId

    // When user opens any modal, we add this class, now if user uses back button without closing the modal
    // and comes back to the PDP page, this class is still there. So now user can't scroll anything.
    // So we need to remove it here.
    document.body.classList.remove("fe-overflow-hidden")
  },
})

// Question And Answer Widget Binding
window.FPI.extension.register(`#${BINDING_ELEMENT_ID.QUESTION_AND_ANSWER}`, {
  mounted(element) {
    window.FPI.extension.mountApp({
      element,
      component: QuestionAndAnswerWidget,
    })
  },
})
